import React, {useState, useEffect} from 'react';
import {
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBCheckbox,
  MDBIcon,
  MDBFile,
  MDBTable, MDBTableHead, MDBTableBody
}
from 'mdb-react-ui-kit';
import { MDBDataTable } from "mdbreact";
import Header from './Header';
import Axios from 'axios'

import {
  faCheck,
  faTimes,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function ViewMessages() {

  const server_app_api_php = window.SERVER_APP_API_PHP

  let [handleSubmitBtn, setHandleSubmitBtn] = useState('')

  const [rows, setDBtableView] = useState([])
    const source = 1;

  
	
    useEffect(() => {
        setHandleSubmitBtn('Loading');
    var formData = new FormData(this)

    formData.append('apiType', 'ViewMessages')
    formData.append('id', source)
   Axios({
      method: 'post',
      url: `${server_app_api_php}/reactphp/index.php`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(function (response) {
        //handle success
       //alert(response.data)
        setHandleSubmitBtn('');
       setDBtableView(response.data)
      })
      .catch(function (response) {
        //handle error
        alert("Error: Check Your Internet Connection")
      })
   
    }, [])


  let data = {
    columns: [
        {
            label: "SN",
            field: "sn"
          },
          {
            label: "From",
            field: "positionSource",
            sort: "asc",
            width: 270
          },
          {
            label: "From(Name)",
            field: "nameSource",
            sort: "asc",
            width: 270
          },
          {
            label: "comments",
            field: "comments",
            sort: "asc",
            width: 150
          },
          {
            label: "To",
            field: "positionDestination",
            sort: "asc",
            width: 270
          },
          {
            label: "To(Name)",
            field: "nameDestination",
            sort: "asc",
            width: 270
          },
      {
        label: "Action",
        field: "messagesID",
        sort: "asc",
        width: 100
      }
    ],
    rows: rows  
  };

  rows.map( (item,index) => {
    if(item.counter != '0'){
    item.sn = (
<div>
    {index +1}
</div>
    );
  }
  });

  rows.map( (item,) => {
    if(item.counter != '0' && item.item !=""){
    item.messagesID = (
<div>
   
<span class="fa fa-eye mr-5"></span>
                                  <span 
                                  onClick={() => {
                                    downloadDoc(item.item)
                                  }}
                                  type='button'
                                  class='fa fa-download green-text'
                                  title='Download Document'
                                ></span>
                                
                                
                                
</div>
    );
   }
  });
  
  const downloadDoc = file => {
    window.open(`${server_app_api_php}/reactphp/messages docs/${file}`)
}
 


  return (
    <MDBContainer fluid className='p-4 background-radial-gradient overflow-hidden'>

 <Header />

      <MDBRow>

      <div hidden={handleSubmitBtn ===''}>
    <div id='overlayer'></div>
    <div class="loader d-flex justify-content-center">
  <div class="spinner-grow text-primary" style={{width: '10rem', height: '10rem'}} role="status">
      <span class='visually-hidden'>Loading...</span>
    </div>
  </div>
  </div>

  

        <MDBCol md='12' className='position-relative text-center text-md-start d-flex flex-column justify-content-center'>

          <MDBCard className='my-5 bg-glass'>
            <MDBCardBody className='p-5'>
     
            <MDBDataTable striped bordered hover small data={data} selectRows={true}  />

             </MDBCardBody>
          </MDBCard>

        </MDBCol>

      </MDBRow>

    </MDBContainer>
  );
}

export default ViewMessages;